import { invoke } from '@shared/easyfy.decorators';
import { globalEvent, element, elements, event } from '@shared/easyfy.core';
import { hide, show } from '@shared/easyfy.utils';
import filterService from '@webServices/filter.service';

namespace Easyfy.Modules {
  @invoke
  export class Filter {
    static Instance: Filter;

    static FilterQuerySelector: string;
    static PagingQuerySelector: string;
    static ItemsQuerySelector: string;
    static SortersQuerySelector: string;
    static FilterFor: FilterFor;
    static Page: number;
    static Sorter: Sorter;
    static SearchString: string;

    static elementsStates: IElementState[];

    constructor(filterFor: FilterFor, filterQuerySelector: string, pagingQuerySelector: string, itemsQuerySelector: string, sortersQuerySelector: string) {
      Filter.FilterQuerySelector = filterQuerySelector;
      Filter.PagingQuerySelector = pagingQuerySelector;
      Filter.ItemsQuerySelector = itemsQuerySelector;
      Filter.SortersQuerySelector = sortersQuerySelector;
      Filter.Page = 1;
      Filter.FilterFor = filterFor;
    }

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          action: 'load-more-items',
          callback: Filter.loadMoreItems
        }
      });

      globalEvent({
        type: 'change',
        event: {
          action: 'change-filter',
          callback: Filter.changeFilter
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'clear-filters',
          callback: Filter.clearFilters
        }
      });

      globalEvent({
        type: 'change',
        event: {
          action: 'change-sort',
          callback: Filter.changeSort
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'change-filter-top',
          callback: Filter.changeFilterTop
        }
      });

      document.addEventListener("change-sort-option", function (e) {
        Filter.changeSort(e);
      });
    }

    static loadMoreItems = (e) => {
      e.preventDefault();
      e.stopPropagation();

      let button: HTMLElement = e.target as HTMLElement;

      if (!button.hasAttribute('data-page-id')) {  
        button = button.parentElement as HTMLElement;  
      }

      const pageId: string = button.attributes['data-page-id']?.value;
      const productListName: string = element('[data-container="products"]')?.attributes["data-list-name"]?.value;
      Filter.Page = button.attributes['data-page']?.value as number;
      Filter.RefreshData(pageId, productListName, false);

      return false;
    }

    static changeFilter = (e) => {
      e.preventDefault();
      e.stopPropagation();

      let input: HTMLElement = e.target as HTMLElement;
      var value = input.attributes['value']?.value;
      var id = input.attributes['id']?.value;

      //if (e.type == "click") {
      //  input = document.querySelector('input[id="' + id + '"]')
      //}

      const pageId: string = input.attributes['data-page-id']?.value?.toString();
      const productListName: string = element('[data-container="products"]')?.attributes["data-list-name"]?.value;

      const filterGroup = input.closest('[data-container="filter-group"]') as HTMLElement;
      var counts = Filter.GetFacetCountsForCurrentGroup(filterGroup.id);
 
      if (input.getAttribute("checked") != null) {
        document.querySelector('[data-container="all-selected-filters"]').querySelector('[value="' + value + '"]').remove();
      } else {
        let span = document.createElement('span');
        span.classList.add('selected-filter');
        span.setAttribute('data-container', 'selected-filter');
        span.setAttribute('value', value);
        span.setAttribute('data-action', "change-filter-top");
        span.setAttribute('data-id', id);
        let i = document.createElement('i');
        i.classList.add('remove-filter');
        i.textContent = "x";
        span.textContent = value;
        span.appendChild(i);
        document.querySelector('[data-container="all-selected-filters"]').appendChild(span);
      }

      Filter.Page = 1;
      Filter.RefreshData(pageId, productListName, true, counts);

      return false;
    }

    static GetFacetCountsForCurrentGroup = (facetGroupKey: string): filterService.IFacetGroupCount => {
      var filterGroup = element('.filter-groups #' + facetGroupKey) as HTMLElement;
      if (!filterGroup) return null;

      var countData: Array<filterService.IFacetValueCount> = [];

      var inputs = filterGroup.querySelectorAll('.filter-row [data-action="change-filter"]')
      inputs.forEach(filterInput => {
        countData.push({
          value: filterInput.attributes["value"]?.value,
          count: Number.parseInt(filterInput.attributes["data-result"]?.value) ?? 0
        });
      });

      var facetGroupCountValues: filterService.IFacetGroupCount = {
        key: facetGroupKey,
        valueCountData: countData
      };

      return facetGroupCountValues;
    }

    static RefreshData = (pageId: string, productListName: string, replaceProducts: boolean = true, facetGroupCount: filterService.IFacetGroupCount = null) => {
      Filter.saveFilterState();

      const urlParams = new URLSearchParams(window.location.search);
      const searchQuery = urlParams.get('q');
  
      var QueryParams: filterService.IQuery = {
        checkedFilters: Filter.getFilterData(),
        page: Filter.Page,
        sorter: {
          key: Filter.Sorter?.key ?? null,
          sortdirection: Number.parseInt(SortDirection[Filter.Sorter?.sortDirection])
        },
        searchString: searchQuery
      };

      if (facetGroupCount) {
        QueryParams.applyFilterGroupCount = facetGroupCount;
      }

      if (QueryParams.sorter.key == null || QueryParams.sorter.sortdirection == null) {
        QueryParams.sorter = null;
      }
      console.log(QueryParams);
      Filter.getItems(pageId, productListName, QueryParams).then((response) => {
        console.log(response)
        if (response.status == 200 && response.data != null && response.data.success) {
          const filterContainer = element(Filter.FilterQuerySelector);
          const pagingContainer = element(Filter.PagingQuerySelector);
          const itemsContainer = element(Filter.ItemsQuerySelector);
          const sorterContainers = elements(Filter.SortersQuerySelector);

          if (replaceProducts && itemsContainer) {
            itemsContainer.innerHTML = response.data.productsPartial;
          } else {
            if (itemsContainer.children.length > 0) {
              itemsContainer.lastElementChild.insertAdjacentHTML('afterend', response.data.productsPartial);
            }
            else {
              itemsContainer.innerHTML = response.data.productsPartial;
            }
          }
          if (filterContainer) {
            filterContainer.innerHTML = response.data.filterPartial;
          }

          if (pagingContainer) {
            pagingContainer.innerHTML = response.data.pagingPartial;
          }

          if (sorterContainers) {
            sorterContainers.forEach(sorterContainer => {
              sorterContainer.innerHTML = response.data.sortPartial;
            })
          }

          document.dispatchEvent(new CustomEvent('filter.totalHitsUpdated', { bubbles: true, detail: { totalHits: response.data.totalHits } }))
          Filter.setFilterState();
          Filter.setUrlParams(QueryParams);

          const clearFilterLink = document.querySelector('[data-action="clear-filters"]');
          if (clearFilterLink) {
            if (QueryParams.checkedFilters.length > 0) {
              show(clearFilterLink, "flex");
            } else {
              hide(clearFilterLink);
            }
          }

        }
      }).catch(error => {
        console.log(error);
      });
    };

    static getItems = async (pageId: string, productListName: string, queryParams: any): Promise<any> => {
      switch (Filter.FilterFor) {
        case FilterFor.Category:
        case FilterFor.Brand:
        case FilterFor.Search:
          const filterForName = FilterFor[Filter.FilterFor];
          return await filterService.GetProducts(pageId, queryParams, filterForName, productListName);
        case FilterFor.Articles:
          return await filterService.GetArticles(pageId, queryParams);
      }
    };

    static getFilterData = (): filterService.IFilter[] => {
      const filterContainer = element(Filter.FilterQuerySelector);
      if (!filterContainer) return;

      let filters: filterService.IFilter[] = [];
      filterContainer.querySelectorAll('[data-container="filter-group"]').forEach((filterGroupElement: HTMLElement) => {
        const key = filterGroupElement.attributes['data-key']?.value;
        let anyValueChecked = false;

        var filter: filterService.IFilter = {
          key: key,
          operator: filterService.FilterOperator.Equal,
          values: []
        };

        filterGroupElement.querySelectorAll('[data-action="change-filter"]:checked').forEach((filterInputElement: HTMLInputElement) => {
          anyValueChecked = true;
          filter.values.push(filterInputElement.value);
        });

        if (anyValueChecked) {
          filters.push(filter);
        }
      });

      return filters;
    };

    static clearFilters = (e) => {
      e.preventDefault();
      e.stopPropagation();
 
      let eventElement: HTMLElement = e.target as HTMLElement;
      let pageId: string = eventElement.attributes['data-page-id']?.value?.toString();
      if (!pageId) {
        pageId = eventElement.parentElement.attributes['data-page-id']?.value?.toString();
      }

      document.querySelector('[data-container="all-selected-filters"]').querySelectorAll('[data-container="selected-filter"]').forEach(el => {
        el.remove();
      })
      if (!pageId)
        return false;
      const filterContainer = element(Filter.FilterQuerySelector);
      const filterCheckboxes = filterContainer.querySelectorAll('input:checked')
      const productListName: string = element('[data-container="products"]')?.attributes["data-list-name"]?.value;

      if (!filterCheckboxes || filterCheckboxes.length < 1)
        return false;

      filterCheckboxes?.forEach(checkbox => {
        checkbox = checkbox as HTMLInputElement;
        checkbox.checked = false;
      });



      Filter.Page = 1;
      Filter.RefreshData(pageId, productListName, true);

      if (!eventElement.hasAttribute('data-action')) {
        eventElement = eventElement.parentElement;
      }

      hide(eventElement);

      return false;
    };

    static changeSort = (e) => {
      e.preventDefault();
      e.stopPropagation();

      const input: HTMLSelectElement = e.target as HTMLSelectElement;
      const pageId: string = input.attributes['data-page-id']?.value?.toString();
      const selectedValue = input.value;
      const sortKey = selectedValue.split('-')[0];
      const direction = selectedValue.split('-')[1];
      const productListName: string = element('[data-container="products"]')?.attributes["data-list-name"]?.value;

      Filter.Page = 1;
      Filter.Sorter = {
        key: sortKey,
        sortDirection: direction
      };
      console.log(Filter.Sorter);
      Filter.RefreshData(pageId, productListName, true);
    };

    static changeFilterTop = (e) => {
      e.preventDefault();
      e.stopPropagation();

      let el = e.target as HTMLElement;
      if (el.attributes["data-id"]?.value == undefined) {
        el = el.parentElement;
      }
      const id = el.attributes["data-id"]?.value;

      const input = document.querySelector('input[id="' + id + '"]');
      input.removeAttribute("checked")
      
      const pageId: string = input.attributes['data-page-id']?.value?.toString();
      const productListName: string = element('[data-container="products"]')?.attributes["data-list-name"]?.value;
      el.remove();
      const filterGroup = input.closest('[data-container="filter-group"]') as HTMLElement;
      var counts = Filter.GetFacetCountsForCurrentGroup(filterGroup.id);
      Filter.Page = 1;
      Filter.RefreshData(pageId, productListName, true, counts);

      return false;
    }

    static saveFilterState = () => {
      let saveElementsState = elements('[data-save-state]');
      if (saveElementsState && saveElementsState.length > 0) {
        Filter.elementsStates = [];
        var tempStates: IElementState[] = []
        saveElementsState.forEach(element => {
          element = element as HTMLElement;

          var elementState = Filter.resolveStateAndValue(element);
          if (elementState) {
            tempStates.push(elementState)
          }
        });

        //arrange states so opens occur before scrolls.
        tempStates.forEach(state => {
          if (state.stateType != StateType.Scroll)
            Filter.elementsStates.push(state);
        });
        tempStates.forEach(state => {
          if (state.stateType == StateType.Scroll)
            Filter.elementsStates.push(state);
        });
      }
    };

    static setFilterState = () => {
      if (!Filter.elementsStates)
        return;
      Filter.elementsStates.forEach(elementState => {
        console.log(elementState)
        var domelement = element("#" + elementState.elementId) as HTMLElement;
        if (!domelement)
          return;
        switch (elementState.stateType) {
          case StateType.Open: {
            if (domelement.nodeName.toLocaleLowerCase() == 'details') {
              if (elementState.value) {
                domelement.setAttribute("open", "true");
              }
            }
          }
          case StateType.Scroll: {
            elementState.stateType = StateType.Scroll;
            domelement.scrollTop = elementState.value;
            break;
          }
        }
      });
    };

    static resolveStateAndValue = (element: HTMLElement): IElementState => {
      var elementState = {} as IElementState;
      if (!element.id)
        return null;

      elementState.elementId = element.id;
      let stateType: StateType = StateType[element.getAttribute('data-save-state')];
      let elementType = element.nodeName.toLowerCase();

      switch (stateType) {
        case StateType.Open: {
          elementState.stateType = StateType.Open;
          if (elementType == 'details') {
            elementState.value = element.hasAttribute("open");
          }
          break;
        }
        case StateType.Scroll: {
          elementState.stateType = StateType.Scroll;
          elementState.value = element.scrollTop;
          break;
        }
      }
      return elementState;
    };

    static setUrlParams = (queryParams: filterService.IQuery) => {
      var urlQuery = new URLSearchParams(window.location.search);

      if (queryParams.page > 1) {
        urlQuery.set("p", queryParams.page.toString());
      }
      else {
        urlQuery.delete("p");
      }

      if (queryParams.checkedFilters.length > 0) {
        var filterQuery = "";
        queryParams.checkedFilters.forEach(filter => {
          filterQuery += filter.key.toString() + ":";
          filterQuery += filter.values.join("|") + ";";
        });

        urlQuery.set("f", filterQuery);
      }
      else {
        urlQuery.delete("f");
      }

      if (queryParams.sorter != null) {
        urlQuery.set("s", queryParams.sorter.key);
        urlQuery.set("d", queryParams.sorter.sortdirection.toString());
      }
      else {
        urlQuery.delete("s");
        urlQuery.delete("d");
      }
      if (urlQuery.toString().length > 0) {
        history.replaceState(null, null, "?" + urlQuery.toString());
      }
      else {
        history.replaceState(null, null, window.location.origin + window.location.pathname);
      }
    };
  }

  export interface IElementState {
    elementId: string;
    stateType: StateType;
    value: any;
  }

  export enum StateType {
    Scroll,
    Open
  }

  export interface Sorter {
    key: string;
    sortDirection: string;
  }

  export enum SortDirection {
    "Ascending" = 0,
    "Descending" = 1
  }

  export enum FilterFor {
    Category,
    Brand,
    Search,
    Articles
  }
}

export default Easyfy.Modules;